import { ExistingSystemType, LevelType } from 'data/types';
import { countDuctedDesignLevels } from 'utils/ducted-design-levels';

export type DuctedDesignRequirementParams = {
  structure: LevelType[];
  existingSystems: ExistingSystemType[];
};

export function countDuctedExistingSystems(
  existingSystems: ExistingSystemType[]
): number {
  return existingSystems.filter((system) => system.type === 'ducted').length;
}

export function requiresDuctedSystemDesign({
  structure,
  existingSystems
}: DuctedDesignRequirementParams): boolean {
  return (
    countDuctedDesignLevels(structure) > 1 ||
    countDuctedExistingSystems(existingSystems) > 1
  );
}
